/**
 * Wie hoch ein Ausschlag in der Tonkurve gezeichnet wird.
 *
 * Bis heute linear: der Ausschlag war der Zahlenwert mal die halbe Höhe. Das
 * klingt richtig und sieht falsch aus. Eine gewöhnliche Aufnahme steht bei
 * −30 dB, das sind 0,03 — bei 46 Punkten Platz sind das anderthalb Punkte.
 * Also eine gerade Linie. Und wenn am Anfang einmal etwas knackt, steht dort
 * ein Balken über die volle Höhe und der Rest bleibt flach. Genau das hat
 * Sascha am 8. September gesehen: „Audio ist ziemlich monoton 🙂 zumindest
 * die Kurve.“
 *
 * Das Ohr hört nicht linear, und Schnittprogramme zeichnen deshalb in Dezibel.
 * Hier auch: der Boden ist die Stille, die Decke die Vollaussteuerung, und
 * dazwischen wird geradlinig verteilt.
 *
 * Der Boden liegt bei −50 dB. Darunter ist Raumton und Rauschen — das soll
 * flach bleiben, sonst sieht eine Pause aus wie ein Satz. Darüber wird es
 * sichtbar: −30 dB sind knapp zwei Fünftel der Höhe, −6 dB fast alles.
 *
 * An den Daten ändert das nichts. Die Wellenform, die der Arbeitsdienst
 * schreibt, bleibt, wie sie ist — es wird nur anders hingemalt. Niemand muss
 * ein Medium noch einmal aufbereiten.
 */
/** Ab hier gilt es als still. */
export const KURVEN_BODEN = -50;
/**
 * Aus einem Ausschlag (0..1) wird eine Höhe (0..1).
 *
 * `boden` ist die Stille in Dezibel; wer eine leise Aufnahme genauer ansehen
 * will, schiebt ihn tiefer.
 */
export function kurvenHoehe(ausschlag, boden = KURVEN_BODEN) {
    if (!(ausschlag > 0))
        return 0;
    if (ausschlag >= 1)
        return 1;
    const db = 20 * Math.log10(ausschlag);
    if (db <= boden)
        return 0;
    return db / -boden + 1;
}
//# sourceMappingURL=kurve.js.map